// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicLauncherWrapper_root__G3i0D","sideEffect":"PlasmicLauncherWrapper_sideEffect__ReFyJ"};